import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Colors } from '../../../utils/resources/colors';

export interface CheckboxCSSStyle extends UIComponentCSSStyle
{
  getCSSStyleOne() : object;
  getCSSStyleTwo() : object;
  getCSSStyleThree() : object;
}

export class CheckboxCSSStyleImpl extends UIComponentCSSStyleImpl implements CheckboxCSSStyle 
{
    getWrapperCSSStyle(): object
    {
      return{
      };
    }

    getCSSStyleOne():Object
    {
        return {
            position: 'relative', 
            width: '18px', 
            height: '18px', 
            cursor: "pointer",
            backgroundColor: this.getResources().getColor(Colors.color_2), 
            borderRadius: '3px'
        };
    }
    getCSSStyleTwo():Object
    {
        return {
            position: 'absolute', height: '4px', 
            width: '9px', top: '5px', left: '5px', 
            borderLeft: 'solid 2px '+ this.getResources().getColor(Colors.color_5), 
            borderBottom: 'solid 2px '+ this.getResources().getColor(Colors.color_5), 
            borderRadius: '0px', 
            cursor: "pointer",
            transform: 'rotate(-45deg)'
        };
    }

    getCSSStyleThree():Object
    {
        return {
            position: 'relative', 
            width: '18px', 
            height: '18px', 
            borderRadius: '3px', 
            cursor: "pointer",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            border: "solid 1px" + this.getResources().getColor(Colors.color_8)
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/checkbox/checkboxcss.tsx